import { ensureFreshStoredAuth, refreshAccessToken, clearStoredAuth } from "./auth";
import { expireAuthSession } from "./authStore";

const API_BASE = (
  (import.meta.env.VITE_SHARED_CONFIG_API_BASE as string | undefined)
  ?? "https://spuerhund-api.cloudeflare-8a5.workers.dev/api"
).replace(/\/$/, "");

/**
 * Authenticated fetch wrapper. Injects JWT, retries once on 401 via refresh.
 */
export async function authFetch(path: string, init?: RequestInit): Promise<Response> {
  const current = await ensureFreshStoredAuth();
  const token = current.accessToken;

  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(init?.headers ?? {}),
    },
  });

  if (response.status === 401) {
    try {
      const refreshed = await refreshAccessToken();
      return fetch(`${API_BASE}${path}`, {
        ...init,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${refreshed.accessToken}`,
          ...(init?.headers ?? {}),
        },
      });
    } catch {
      clearStoredAuth();
      expireAuthSession();
      throw new Error("Session expired");
    }
  }

  return response;
}
